import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import OtherCostTableRow from './OtherCostTableRow';
import OtherCostForm from './OtherCostForm';
import { OtherCost } from '../../models/OtherCost';
import { clone, getParent, getSnapshot, applySnapshot } from 'mobx-state-tree';

class OtherCostsList extends Component {
  
  state = {
    isFormOpen: false,
    selectedItem: null,
    clone: null
  }

  render() {
    return (
      <div>
        <Table striped compact='very'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={8}>Description</Table.HeaderCell>
              <Table.HeaderCell width={3}>Cost</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
          {this.props.items.map((cost, index) => <OtherCostTableRow key={index} item={cost} onEdit={this.editCost} onRemove={this.removeItem} /> )}
            <Table.Row>
              <Table.Cell colSpan={4}>
                <a href='#add-new-additional-cost' onClick={this.addCost}>Add new additional cost</a>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        {this.state.isFormOpen &&
          <OtherCostForm model={this.state.clone} onSave={this.commitChanges} onClose={this.cancelEdit} />
        }
      </div>
    )
  }

  addCost = () => {
    this.setState({
      selectedItem: null,
      clone: OtherCost.create(),
      isFormOpen: true
    })
  }

  editCost = cost => {
    this.setState({
      selectedItem: cost,
      clone: clone(cost),
      isFormOpen: true
    })
  }

  cancelEdit = () => {
    this.setState({ 
      selectedItem: null,
      clone: null,
      isFormOpen: false
    })
  }

  commitChanges = () => {
    const { clone } = this.state;
    const job = getParent(this.props.items)
    if (this.state.selectedItem) {
      applySnapshot(this.state.selectedItem, getSnapshot(clone))
    } else {
      job.addOtherCost(clone)
    }
    job.recalculateOtherCostsForAllEstimates()
    this.cancelEdit()
  }

  removeItem = item => {
    const job = getParent(this.props.items)
    item.remove()
    job.recalculateOtherCostsForAllEstimates()
  }
}
 
export default observer(OtherCostsList);


// WEBPACK FOOTER //
// ./src/components/jobs/OtherCostTable.js